import { UserAuthContext } from "context/UserAuthContext";
import MainLayout from "layout/MainLayout";
import { useContext } from "react";
import { Navigate, Outlet } from "react-router-dom";

export const ProtectedRoute = () => {
    const { hasSubscription } = useContext(UserAuthContext);
    const loggedIn = localStorage.getItem('token') !== null && localStorage.getItem('user') !== null;
    if (!loggedIn) {
      // user is not authenticated
      return <Navigate to="/login" />;
    }
    if(!hasSubscription()){
        // return <Notice color="error">You need a subscription to view this page</Notice>
        return <Navigate to="/subscriptions" />;
    }
    return <MainLayout />;
  };